import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapePredefinedProcess extends Shape {
    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 3) / 5 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.lineTo(x + width, y);
        canv.ctx.lineTo(x + width, y + height);
        canv.ctx.lineTo(x, y + height);
        canv.ctx.lineTo(x, y);

        // второй слой
        canv.ctx.lineTo(x, y + height / 2);

        canv.ctx.moveTo(x + width / 5, y);
        canv.ctx.lineTo(x + width / 5, y + height);

        canv.ctx.moveTo(x + (width * 4) / 5, y);
        canv.ctx.lineTo(x + (width * 4) / 5, y + height);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="24" height="24" rx="1.5" fill="${fill}" stroke="${stroke}"/>
                <line x1="20.1875" x2="20.1875" y2="24.6875" stroke="${stroke}"/>
                <line x1="5.5" x2="5.5" y2="24.6875" stroke="${stroke}"/>
            </svg>
        `;
    }
}
